import type { RouteRecordRaw } from 'vue-router'
/**
 * 路由 meta 字段说明
 * @property title       底部 tab 导航名称（兼作默认 navbar 标题）
 * @property navbarTitle 自定义 navbar 标题，不设则用 title
 * @property icon        底部 tab 导航图标
 * @property login       是否需要登录，默认 true
 * @property tab         是否展示底部导航，默认 false
 * @property keepAlive   是否缓存页面
 */
declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    /** 自定义 navbar 标题，不设则用 title */
    navbarTitle?: string
    /** 底部 tab 导航图标 */
    icon?: string
    /** 是否需要登录，默认 true */
    login?: boolean
    /** 是否展示底部导航，默认 false */
    tab?: boolean
    keepAlive?: boolean
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
      navbarTitle: '医生列表',
      icon: 'home-o',
      login: false,
      tab: true,
      keepAlive: true
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '关于',
      icon: 'info-o',
      login: false,
      tab: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
      login: false
    }
  },
  {
    path: '/doctor',
    name: 'Doctor',
    component: () => import('@/views/doctor/index.vue'),
    meta: {
      title: '医生详情',
      login: false
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/profile/index.vue'),
    meta: {
      title: '我的',
      icon: 'user-o',
      tab: true
    }
  },
  {
    // 404 兜底
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '页面不存在',
      login: false
    }
  }
]

export default routes
